import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=a99009b2"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a99009b2')) {
      api.createRecord('a99009b2', component.options)
    } else {
      api.reload('a99009b2', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=a99009b2", function () {
      api.rerender('a99009b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/PageNotFound.vue"
export default component.exports